/**
 * Aggregate a 1440-length minute array into hour/day/minute series
 */

export function aggregateMinutes(arr, mode, options = {}) {
  if (!Array.isArray(arr) || arr.length === 0) return [];

  const divisor = options.divideBy ?? 1; // e.g. /2 for Avg Active

  // ----------------
  // DAY
  // ----------------
  if (mode === "day") {
    const sum =
      arr.reduce((a, b) => a + Number(b || 0), 0) / divisor;

    return [Math.round(sum)];
  }

  // ----------------
  // HOUR
  // ----------------
  if (mode === "hour") {
    return Array.from({ length: 24 }, (_, h) => {
      const slice = arr.slice(h * 60, h * 60 + 60);
      const sum =
        slice.reduce((a, b) => a + Number(b || 0), 0) / divisor;
      return Math.round(sum);
    });
  }

  // ----------------
  // MINUTE
  // ----------------
  return arr.map((v) => Math.round(Number(v || 0) / divisor));
}
